import ReadPersonaPopup from './ReadPersonaPopup';

export default ReadPersonaPopup;
